import * as React from 'react';
import { TranslationService } from "../../../common";
import { IntelligentAssignmentSummary, IntelligentEstimatorMenuConfig } from '../../constants';
import { IntelligentPhotoCaptureEstimatorCaptureMode } from '../../enums';
import { StyledIntelligentLandingPageContent, StyledHeading, StyledLandingPageTitle, StyledPhotoOptionCard, StyledPhotoOptionIcon, StyledPhotoOptionsContainer } from './IntelligentAssignmentSummaryLandingPageComponent.style';
export const IntelligentAssignmentSummaryLandingPageComponent = ({ onUploadClick, shouldUseOnlyCamera }) => {
    const translateFn = TranslationService.translate;
    const photoOptions = shouldUseOnlyCamera
        ? IntelligentEstimatorMenuConfig.filter(option => option.captureMode !== IntelligentPhotoCaptureEstimatorCaptureMode.BULK_PHOTOS)
        : IntelligentEstimatorMenuConfig;
    return (React.createElement(StyledIntelligentLandingPageContent, null,
        React.createElement(StyledLandingPageTitle, null,
            translateFn(IntelligentAssignmentSummary.LANDING_PAGE_TITLE),
            " "),
        React.createElement(StyledPhotoOptionsContainer, null, photoOptions.map(option => (React.createElement(StyledPhotoOptionCard, { role: "button", tabIndex: 0, key: option.captureMode, onClick: () => onUploadClick(option.captureMode) },
            React.createElement(StyledPhotoOptionIcon, { className: option.icon }),
            React.createElement(StyledHeading, null, translateFn(option.captureMode))))))));
};
//# sourceMappingURL=IntelligentAssignmentSummaryLandingPageComponent.js.map